import { render } from "./BtnLink.vue?vue&type=template&id=51a80560"
const script = {}

import exportComponent from "/srv/apps/jenkins/workspace/Hybris/PACK-zip-archives-for-deployment-v3/bin/custom/ocm/ocmstorefront/web/webroot/WEB-INF/_ui-src/packages/contact/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__